import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';
import InputMask from 'react-input-mask';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class NroPrespuestoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            codigo:null,
            ott_id: null,
            uvt_id: null,
            solicitud_id: null,
            nro: 'P0000-00',
            nro: 'AA0000',

        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            ott_id: null,
            uvt_id: null,
            solicitud_id: null,
            nro: 'P0000-00',
            nro: 'AA0000',
        })
    }

    setSelects(data) {
        this.setState({
            codigo: null,
            uvt_id: data.uvt_id,
            ott_id: data.ott_id,
            solicitud_id: data.solicitud_id,
            nro: data.nro,
            codigo: data.codigo,
        });
    }

    render() {
        return (
            <ParadigmaModal
                buttonClass={"btn-warning"}
                buttonLabel={"Prespuesto"}
                getUrl={api.proyectos.presupuesto.asignar}
                postUrl={api.proyectos.presupuesto.asignar}
                onSubmit={() => {this.props.onSubmit()}}
                id={this.props.id}
                successMessage={"El Código ha sido asignado con éxito."}
                notAllowedMessage={"El Código ya ha sido asignado."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Falta asignar número de presupuesto"}
                buttonTitle={"Asignar número de presupuesto"}
                buttonIcon={"fa fa-exclamation-triangle"}
                
                danger={true}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                saveButtonLabel={"Asignar"}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <Input type="hidden" name="plan_id" disabled={true} />
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del proyecto</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Código</Label>
                                {this.state.codigo &&
                                    <InputMask disabled={true} className="form-control" mask="aa-9999" value={this.state.codigo} type="text" />
                                }
                            </div>
                            <div className="ui-field">
                                <Label>Proyecto</Label>
                                <ParadigmaAsyncSeeker fieldName={"solicitud_id"}
                                    url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Oficina de Transf. Técnica</Label>
                                <ParadigmaAsyncSeeker disabled={true} fieldName={"ott_id"} url={api.proyectos.config.presupuesto.ott.select}
                                    onChange={(e) => this.setState({ ott_id: e.pk })} value={this.state.ott_id} />
                                <FormFeedback />
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Unidad de Vinculación</Label>
                                <ParadigmaAsyncSeeker disabled={true} fieldName={"uvt_id"} url={api.proyectos.config.presupuesto.uvt.select}
                                    onChange={(e) => this.setState({ uvt_id: e.pk })} value={this.state.uvt_id} />
                                <FormFeedback />
                            </div>
                        </div>
                    </section>
                    <section className="ui-section-block">
                        <p className="ui-section-label">Presupuesto</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nº de Presupuesto</Label>
                                <InputMask invalid className="form-control" mask="P9999-99" value={this.state.nro} onChange={(e) => this.setState({ nro: e.target.value })}
                                    name="nro" type="text" />
                            </div>
                        </div>
                    </section>
                </div>

            </ParadigmaModal>
        );
    }
}

export default NroPrespuestoModal;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento5/NroPresupuestoModal.js